import React, { useState } from "react";

export default function WeatherTemperature(props) {

    const [unit, setUnit] = useState("metrics");

    function showFahrenheit(event) {
        event.preventDefault();
        setUnit("Fahrenheit");
    }

    function showCelsius(event) {
        event.preventDefault();
        setUnit("metrics");
    }

    if (unit === "metrics") {
        return (
            <span className="WeatherTemperature">
                <span className="temperature">{Math.round(props.celsius)}
                </span>
                <span className="units">
                    °C
                    | <a href=" " onClick={showFahrenheit}>°F</a>
                </span>
            </span>
            )
    } else {
        let fahrenheit = (props.celsius * 9) / 5 + 32;
        return (
            <span className="WeatherTemperature">
                <span className="temperature">{Math.round(fahrenheit)}
                </span>
                <span className="units">
                    <a href=" " onClick={showCelsius}>°C </a> 
                    | °F
                </span>
            </span>
            )
    }
}